export type AppSource = 'Mobiliar' | 'Protekta';
export type AppContext = 'B2C' | 'B2E';
export const B2E: AppContext = 'B2E';
export const B2C: AppContext = 'B2C';
export const PROTEKTA: AppSource = 'Protekta';
export const MOBILIAR: AppSource = 'Mobiliar';
export const BRANDS = {
    MOBILIAR: 'mobiliar',
    PROTEKTA: 'protekta',
} as const;
export type LocalBrand = (typeof BRANDS)[keyof typeof BRANDS] | undefined;
// Protekta Urls
export const PROTEKTA_B2E_PREPRODUCT_URL = 'https://b2e.oiv-protekta.mobiliar-preprod.ch';
export const PROTEKTA_B2C_PREPRODUCT_URL = 'https://oiv-protekta.mobiliar-preprod.ch';
export const PROTEKTA_B2E_PRODUCT_URL = 'https://b2e.oiv-protekta.mobiliar.ch';
export const PROTEKTA_B2C_PRODUCT_URL = 'https://oiv-protekta.mobiliar.ch';
export const OLD_PROTEKTA_B2C_DOMAINS = ['oiv.protekta.ch'];
// Mobiliar Urls
export const MOBILIAR_B2E_PREPRODUCT_URL = 'https://b2e.oiv.app.mobiliar-preprod.ch';
export const MOBILIAR_B2C_PREPRODUCT_URL = 'https://oiv-viewer-b2c.app.mobiliar-preprod.ch/';
export const MOBILIAR_B2E_PRODUCT_URL = 'https://b2e.oiv.app.mobiliar.ch/';
export const MOBILIAR_B2C_PRODUCT_URL = 'https://oiv-viewer-b2c.app.mobiliar.ch/';

export const AppSourceUrlMap = {
    [MOBILIAR]: {
        [B2C]: {
            preproduct: MOBILIAR_B2C_PREPRODUCT_URL,
            product: MOBILIAR_B2C_PRODUCT_URL,
        },
        [B2E]: {
            preproduct: MOBILIAR_B2E_PREPRODUCT_URL,
            product: MOBILIAR_B2E_PRODUCT_URL,
        },
    },
    [PROTEKTA]: {
        [B2C]: {
            preproduct: PROTEKTA_B2C_PREPRODUCT_URL,
            product: PROTEKTA_B2C_PRODUCT_URL,
        },
        [B2E]: {
            preproduct: PROTEKTA_B2E_PREPRODUCT_URL,
            product: PROTEKTA_B2E_PRODUCT_URL,
        },
    },
};

export const PAGE_URL_PATH = {
    HOMEPAGE: 'homepage',
    NOT_FOUND: 'not-found',
    NOT_AVAILABLE: 'not-available',
    NO_PERMISSION: 'no-permission',
};

export const URL_PATH = {
    AVB: 'avb',
    CHAPTERS: 'chapters',
    TOPICS: 'topics',
};

export const URL_CONST = [
    {
        domain: 'oiv.mobiliar.ch',
        language: 'de',
    },
    {
        domain: 'oiv.mobiliare.ch',
        language: 'it',
    },
    {
        domain: 'oiv.mobiliere.ch',
        language: 'fr',
    },
];

export const PROTEKTA_URL_CONST = [
    {
        domain: 'oiv-protekta.mobiliar.ch',
        language: 'de',
    },
    {
        domain: 'oiv-protekta.mobiliare.ch',
        language: 'it',
    },
    {
        domain: 'oiv-protekta.mobiliere.ch',
        language: 'fr',
    },
];

export const LIST_LANGUAGE: string[] = ['de', 'fr', 'it'];

export const TABLE_EXCLUDED = '<excluded>';
export const TABLE_INCLUDED = '<included>';
